import { render, staticRenderFns } from "./AvatarDescription.vue?vue&type=template&id=99606c9a&scoped=true&"
import script from "./AvatarDescription.vue?vue&type=script&lang=ts&"
export * from "./AvatarDescription.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarDescription.vue?vue&type=style&index=0&id=99606c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99606c9a",
  null
  
)

export default component.exports